import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IESCardInfo } from '@app/modules/entry-summary/interfaces';
import { enumDropdownActionIconColor, enumDropdownActionMenuMode } from '@shared/form-wrapper/enums';

@Component({
  selector: 'es-details-card',
  templateUrl: './es-details-card.component.html',
  styleUrls: ['./es-details-card.component.scss'],
})
export class EsDetailsCardComponent implements OnInit {
  @Input() public canEdit: boolean = false;
  @Input() public info: IESCardInfo = null;
  @Input() public index: number;
  @Input() public canDelete: boolean = false;
  @Input() public isMissing: boolean = false;
  @Output() public edit: EventEmitter<any> = new EventEmitter<any>();
  @Output() public delete: EventEmitter<any> = new EventEmitter<any>();

  public iconColor: enumDropdownActionIconColor = enumDropdownActionIconColor.WHITE;
  public menuMode: enumDropdownActionMenuMode = enumDropdownActionMenuMode.DEFAULT;

  public isBLConfirmModalOpen: boolean;

  constructor() {}

  public ngOnInit(): void {}

  public gotoEdit() {
    this.edit.emit();
  }

  public onDelete() {
    this.delete.emit();
    this.isBLConfirmModalOpen = false;
  }
}
